import firebase from "../../config/firebase"

export const getSurvey = () => (dispatch) => {
    firebase.firestore().collection("survey").onSnapshot(async (query) => {
        let temp_data = []
        query.forEach((doc) => {
            temp_data.push({
                ...doc.data()
            })
        })
        dispatch({
            type:"SURVEY-DATA",
            payload:temp_data
        })
    })
}